<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-column flex h-full text-base dark:bg-contrast-black">
        <div class="px-4 py-5">
            <p class="text-center font-bold">{{ 'PERMISSION_NOT_GRANTED' | translate }}</p>
        </div>
        <div class="flex-align-center mx-5 flex justify-between px-2 py-1 text-center">
            {{ 'PERMISSION_NOTIFICATION_SETTING' | translate }}
        </div>
        <div class="m-4 mt-2 flex flex-col items-center gap-2">
            <button
                class="modal-cancel-button sr-app-light:text-[#147742] h-14 w-full rounded-lg font-bold dark:text-contrast-yellow"
                (click)="cancel()">
                {{ 'LOCAL_BTN_CANCEL' | translate }}
            </button>
            <button
                class="modal-confirm-button sr-app-light:text-white h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                (click)="openDeviceSetting()">
                {{ 'LOCAL_BTN_OPEN_SETTING' | translate }}
            </button>
        </div>
    </div>
</div>
